import { Sparkles, Layers, Building2, Wrench } from "lucide-react";

const benefits = [
  {
    icon: Sparkles,
    title: "Visuele transformatie",
    text: "Glas, ramen en muren worden direct een statement in elke ruimte.",
  },
  {
    icon: Layers,
    title: "Moderne uitstraling",
    text: "Strakke, premium afwerking zonder rommelige installaties of gordijnen.",
  },
  {
    icon: Building2,
    title: "Voor woning én bedrijf",
    text: "Van badkamer tot boardroom, van showroom tot horecazaak.",
  },
  {
    icon: Wrench,
    title: "Advies, levering & installatie",
    text: "Één partner van eerste intake tot oplevering — duidelijk en ontzorgend.",
  },
];

export default function Benefits() {
  return (
    <section
      className="relative py-24 md:py-32"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-4">
              Waarom JYNOVA?
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight leading-[1.05]">
              Geen losse producten.{" "}
              <span className="italic" style={{ color: "#C5A059" }}>
                Complete transformaties.
              </span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-zinc-400 font-body leading-relaxed">
              Wij verkopen geen losse producten, maar complete transformaties:
              van transparantie naar privacy, van glas naar display en van muur
              naar design.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {benefits.map((b) => {
              const Icon = b.icon;
              return (
                <div
                  key={b.title}
                  className="jn-glass jn-card-hover rounded-3xl p-7 md:p-8"
                  data-testid={`benefit-${b.title.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center mb-5 border border-cyan-400/30"
                    style={{ background: "rgba(0,229,255,0.08)" }}
                  >
                    <Icon size={20} className="text-cyan-400" />
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl text-white font-medium tracking-tight">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-sm md:text-base text-zinc-400 font-body leading-relaxed">
                    {b.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
